import {createQueryKeys} from "../../shared/query/query-keys";

export const userManagementUserKeys = createQueryKeys("user-management-users");

export const userManagementUserMutationKeys = {
  inviteUserManagementUser: [
    "user-management-users",
    "mutation",
    "invite-user-management-user",
  ] as const,
  activateCurrentUserManagementUser: [
    "user-management-users",
    "mutation",
    "activate-current-user-management-user",
  ] as const,
  resendUserManagementInvitation: [
    "user-management-users",
    "mutation",
    "resend-user-management-invitation",
  ] as const,
  suspendUserManagementUser: [
    "user-management-users",
    "mutation",
    "suspend-user-management-user",
  ] as const,
  reactivateUserManagementUser: [
    "user-management-users",
    "mutation",
    "reactivate-user-management-user",
  ] as const,
  updateUserManagementProfile: [
    "user-management-users",
    "mutation",
    "update-user-management-profile",
  ] as const,
};
